import { Injectable } from "@angular/core";
import { VisionboardItemAddRemoveUiServiceBase } from "../../visionboard";

@Injectable()
export class VenueAdminInventoryItemAddRemoveUiService extends VisionboardItemAddRemoveUiServiceBase {
  addButtonTooltip: string = "Add Venue Item";
  removeButtonTooltip: string = "Remove Venue Item";
  addButtonLargeText: string = "Add Venue Item";
  removeButtonLargeText: string = "Remove Venue Item";
}
